import React from 'react';
import {
    Avatar,
    Box,
    Divider,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { ReactComponent as DownloadAppStoreBadgeLogo } from '../../assets/DownloadAppStoreBadge.svg';
import { ReactComponent as DownloadGooglePlayBadgeLogo } from '../../assets/DownloadGooglePlayBadge.svg';

interface AppVerifyStepProps {
    qrCode: string | null;
    setCode: (code: string) => void;
    isFirstTime: boolean;
}

export const AppVerifyStep = ({ qrCode, setCode, isFirstTime }: AppVerifyStepProps) => {
    const __ = (window as any).__ ? (window as any).__ as (text: string, ...args: Array<string | number>) => string : (text: string, ...args: Array<string | number>) => text;

    return isFirstTime ? (
        <Box>
            <Typography sx={{ mb: 2 }} variant="body2" color="text.secondary" gutterBottom align="center">
                {__('Użyj aplikacji takiej jak Google Authenticator, Microsoft Authenticator lub Authy, aby generować kody bezpieczeństwa.')}
            </Typography>
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <a href="https://play.google.com/store/search?q=authenticator&c=apps" target="_blank" rel="noreferrer">
                    <DownloadGooglePlayBadgeLogo height="40" width="120" />
                </a>
                <a href="https://www.apple.com/pl/search/authenticator?src=globalnav" target="_blank" rel="noreferrer">
                    <DownloadAppStoreBadgeLogo height="40" width="120" />
                </a>
            </Stack>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1, mb: 2 }}>
                <Avatar sx={{ bgcolor: 'primary.main', width: 24, height: 24 }}>
                    <Typography variant="body2" sx={{ color: 'white' }}>1</Typography>
                </Avatar>
                <Typography variant="body2">
                    {__('Otwórz aplikację na swoim telefonie.')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1, mb: 2 }}>
                <Avatar sx={{ bgcolor: 'primary.main', width: 24, height: 24 }}>
                    <Typography variant="body2" sx={{ color: 'white' }}>2</Typography>
                </Avatar>
                <Typography variant="body2">
                    {__('Zeskanuj kod QR, który widzisz poniżej:')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 1, mb: 2 }}>
                {qrCode && (
                    <img src={qrCode} alt="QR Code" />
                )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1, mb: 2 }}>
                <Avatar sx={{ bgcolor: 'primary.main', width: 24, height: 24 }}>
                    <Typography variant="body2" sx={{ color: 'white' }}>3</Typography>
                </Avatar>
                <Typography variant="body2">
                    {__('Wpisz 6-cyfrowy kod wygenerowany przez aplikację:')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 1, mb: 4 }}>
                {qrCode && (
                    <TextField
                        autoComplete="off"
                        slotProps={{
                            htmlInput: {
                                maxLength: 6,
                                sx: { textAlign: 'center' }
                            },
                        }}
                        size="small"
                        id="otp-code"
                        label={__('Twój sekretny kod')}
                        onChange={(e) => setCode(e.target.value)}
                    />
                )}
            </Box>
        </Box>
    ) : (
        <Box>
            <Typography sx={{ mb: 2 }} variant="body2" color="text.secondary" gutterBottom align="center">
                {__('Otwórz aplikację uwierzytelniającą na swoim telefonie i przepisz wygenerowany 6-cyfrowy kod.')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 1, mb: 4 }}>
                <TextField
                    autoComplete="off"
                    slotProps={{
                        htmlInput: {
                            maxLength: 6,
                            sx: { textAlign: 'center' }
                        },
                    }}
                    size="small"
                    id="otp-code"
                    label={__('Twój sekretny kod')}
                    onChange={(e) => setCode(e.target.value)}
                />
            </Box>
        </Box>
    );
};